/**
 * Tour artwork.
 *
 * Posters aren't one shape — some are 848×1216, others 912×1136 — so the frame
 * takes a width and lets the artwork fill a 2:3 box rather than forcing a
 * height that scales some of them up and reads as a zoom.
 *
 * `fill` hands sizing to the parent instead, for grids and for anywhere the
 * artwork has to match a neighbouring element's height.
 */
export default function Poster({
  url,
  width = 96,
  alt = '',
  fill = false,
}: {
  url?: string | null
  width?: number
  alt?: string
  /** Fill the parent rather than sizing from `width`. */
  fill?: boolean
}) {
  const height = Math.round(width * 1.42)
  const box = fill
    ? { width: '100%', height: '100%' }
    : { width, height, flex: 'none' as const }

  if (!url) {
    return (
      <div
        aria-hidden
        style={{
          ...box,
          borderRadius: 8,
          border: 'var(--hairline-width) solid var(--hairline)',
          background:
            'linear-gradient(140deg, var(--accent-wash), var(--panel-raised))',
        }}
      />
    )
  }

  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      style={{
        ...box,
        objectFit: 'cover',
        borderRadius: 8,
        border: 'var(--hairline-width) solid var(--hairline)',
        background: 'var(--panel-raised)',
      }}
    />
  )
}
